import { Loader2Icon } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'

type CancelBookingConfirmDialogProps = {
    open: boolean
    onOpenChange: (open: boolean) => void
    onConfirm: () => void
    pending?: boolean
    /** Course and time of the booking, e.g. "Yoga Flow · 02.11.2026 um 18:00" */
    label?: string | null
    /** Set when staff cancel for a member: their name; deadlines do not apply. */
    memberName?: string | null
}

/** Asks before a booking is cancelled; the cancellation itself cannot be undone (only booked again). */
export function CancelBookingConfirmDialog({
    open,
    onOpenChange,
    onConfirm,
    pending = false,
    label,
    memberName,
}: CancelBookingConfirmDialogProps) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>Buchung stornieren?</DialogTitle>
                    {label && <DialogDescription>{label}</DialogDescription>}
                </DialogHeader>
                <p className="text-sm text-muted-foreground">
                    {memberName
                        ? `Die Buchung von ${memberName} wird storniert, ohne Rücksicht auf die Fristen. Die verwendeten Credits werden erstattet; Gäste und offene Einladungen entfallen.`
                        : 'Die verwendeten Credits werden dir wieder gutgeschrieben. Gäste und offene Einladungen dieser Buchung entfallen.'}
                </p>
                <DialogFooter className="gap-2 sm:gap-0">
                    <Button variant="outline" onClick={() => onOpenChange(false)} disabled={pending}>
                        Zurück
                    </Button>
                    <Button variant="destructive" onClick={onConfirm} disabled={pending}>
                        {pending ? (
                            <>
                                <Loader2Icon className="mr-2 h-4 w-4 animate-spin" />
                                Wird storniert...
                            </>
                        ) : (
                            'Ja, stornieren'
                        )}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
